import clsx from "clsx";
import { useToasts } from "react-toast-notifications";

import { IconButton } from "@shared/buttons";
import { TextInput } from "@shared/text-input";

interface TextBoxWithCopyButtonProps {
  text: string;
  label?: string;
  textCopiedNotificationMessage?: string;
  className?: string;
}
const TextBoxWithCopyButton = ({
  text,
  label,
  textCopiedNotificationMessage = "Copied to clipboard!",
  className,
}: TextBoxWithCopyButtonProps) => {
  const { addToast } = useToasts();

  return (
    <TextInput
      label={label}
      value={text}
      className={className}
      rightIcon={
        <IconButton
          className={clsx("py-0.5 px-2.5 -mr-1.5", { "mt-6": !!label })}
          variant="tertiary"
          onClick={async () => {
            if (!text) {
              return;
            }

            await navigator.clipboard.writeText(text);
            addToast(textCopiedNotificationMessage, { appearance: "success" });
          }}
        >
          <i className="fa-sharp fa-regular fa-copy text-sm" />
        </IconButton>
      }
      disabled
    />
  );
};

export default TextBoxWithCopyButton;
